import { Room } from '../domain';

export const showAllPanelHoles = (room: Room, show: boolean) => {
    for(const wall of room.walls) {
        for(const panel of wall.panels) {
            panel.showLeftFaceHoles = show;
            panel.showRightFaceHoles = show;
        }
    }
}
export default showAllPanelHoles;
